import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/less_than_black.svg'


const _hoisted_1 = { class: "project-creation-view-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "project-creation-view-title-text h5" }
const _hoisted_4 = { class: "project-name-input-field-wrapper" }
const _hoisted_5 = { class: "asterisk-icon default-text-orange" }
const _hoisted_6 = { class: "project-color-selector-component-wrapper" }
const _hoisted_7 = { class: "asterisk-icon default-text-orange" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "project-creation-divider" }, null, -1)
const _hoisted_9 = { class: "project-creation-button-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_color_selector = _resolveComponent("color-selector")!
  const _component_ta_button = _resolveComponent("ta-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "project-creation-view-back-button small-text-grey",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leavePage()))
      }, [
        _hoisted_2,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("component-new-task-view.back")), 1)
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("local-task-component-locales.new-project")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.requiredSymbol), 1),
        _createElementVNode("input", {
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.projectNameValue && _ctx.projectNameValue(...args))),
          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.projectNameValue && _ctx.projectNameValue(...args))),
          maxlength: "120",
          ref: "projectNameInput",
          class: "project-name-area small-text",
          type: "text",
          placeholder: "Project Name"
        }, null, 544)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["small-text-salmon error-message-project-creation", { hideElement: _ctx.hideFirstError }])
      }, _toDisplayString(_ctx.firstErrorMessageText), 3),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.requiredSymbol), 1),
        _createVNode(_component_color_selector, {
          ref: "colorSelector",
          onSelectedColor: _ctx.updateSelectedColor
        }, null, 8, ["onSelectedColor"])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["small-text-salmon error-message-project-creation", { hideElement: _ctx.hideSecondError }])
      }, _toDisplayString(_ctx.secondErrorMessageText), 3),
      _hoisted_8,
      _createElementVNode("textarea", {
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateOptionalText())),
        type: "text",
        ref: "projectDescription",
        class: "project-optional-description-block default-text",
        placeholder: "Describe the main goal (optional)"
      }, null, 544),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_ta_button, {
          class: "cancel-button-local",
          text: _ctx.cancelText,
          backgroundColor: 'gray-dark-text',
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.leavePage()))
        }, null, 8, ["text"]),
        _createVNode(_component_ta_button, {
          class: "next-button",
          text: _ctx.saveText,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveProject()))
        }, null, 8, ["text"])
      ])
    ])
  ]))
}